import Carriers from '../components/carriers/Carriers';
import CarriersCreate from '../components/carriers/CarriersCreate';
import CarriersEdit from '../components/carriers/CarriersEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/carriers',
  component: Template,
  children: [
    {
      path: '',
      name: 'Carriers',
      component: Carriers,
      meta: {
        title: 'Carriers - Mod24',
      },
    },
    {
      path: 'create',
      name: 'CarriersCreate',
      component: CarriersCreate,
      meta: {
        title: 'Create Carrier - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'CarriersEdit',
      component: CarriersEdit,
      meta: {
        title: 'Edit Carrier - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/carriersRoutes.js